import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppStore } from '../../store/useAppStore'
import { Button } from '../ui/Button'
import { Icon } from '../ui/Icon'

/**
 * 导出按钮组件
 * 点击打开导出模态框
 */
export const ExportButton: React.FC = () => {
  const { t } = useTranslation()
  const { toggleExportModal } = useAppStore()

  return (
    <Button
      onClick={toggleExportModal}
      variant="secondary"
      size="sm"
      className="gap-2 whitespace-nowrap flex-shrink-0"
      title={t('nav.export')}
    >
      <Icon name="export" size={16} />
      <span className="hidden sm:inline">{t('nav.export')}</span>
    </Button>
  )
}